import React, { ReactNode } from "react";
import { Box, Typography, useTheme } from "@mui/material";

type AssistantPageDetailsProps = {
  title: string;
  children: ReactNode;
  mb?: string;
};

export const AssistantPageDetails = ({
  title,
  children,
  mb = "25px",
}: AssistantPageDetailsProps) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        p: "40px",
        minHeight: "470px",
        minWidth: "330px",
        width: "30%",
        backgroundColor: "white",
        border: "1px solid #F3F3F3",
        borderRadius: "6px",

        "@media screen and (max-width: 1600px)": {
          minWidth: "30%",
        },
      }}
    >
      <Box
        sx={{
          pb: "20px",
          mb,
          borderBottom: `1px solid ${theme.palette.secondary.main}`,
        }}
      >
        <Typography variant="h3">{title}</Typography>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column" }}>{children}</Box>
    </Box>
  );
};

export default AssistantPageDetails;
